var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarRating = function SvgStarRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "#FF9406",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 0 2.02 6.219h6.54l-5.29 3.843 2.02 6.22L9 12.437 3.71 16.28l2.02-6.219L.44 6.22h6.54L9 0Z"
  })));
};
export { SvgStarRating as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0iI0ZGOTQwNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEwxMS4wMjA2IDYuMjE4ODVIMTcuNTU5NUwxMi4yNjk0IDEwLjA2MjNMMTQuMjkwMSAxNi4yODEyTDkgMTIuNDM3N0wzLjcwOTkzIDE2LjI4MTJMNS43MzA1NiAxMC4wNjIzTDAuNDQwNDkyIDYuMjE4ODVINi45NzkzN0w5IDBaIiBmaWxsPSIjRkY5NDA2Ii8+Cjwvc3ZnPgo=";